export enum EventStatus {
    Active,
    Past,
    Cancelled,
    FullyBooked,
    LimitedSpaces,
    WaitingList,
    Scheduled,
    NotLive,
    NotListed,
}